import React from 'react';
import Select from 'react-select';
import { NumericFormat } from 'react-number-format';
import Input from '../Input';
import * as S from './styles';
import { themeForSearchableSelect } from '../../util/themeForSearchableSelect';

const CustomField = ({
  entity,
  field, 
  value, 
  onChange, 
  onBlur, 
  disabled 
}) => {
  const label = field.name;
  const htmlLabel = (field.requiredIn === 2 || field.requiredIn === 3) && entity != 2
    ? <>{label} <S.RequiredBadge>*</S.RequiredBadge></>
    : label;
    const currentValue = value != undefined ? value : '';
    
  switch (field.type) {
    case 1: // Texto curto
      return (
        <S.CustomFieldWrapper key={field.id}>
          <Input
            id={field.id}
            type='text'
            label={htmlLabel}
            name={`customField_${field.id}`}
            value={currentValue || ''}
            onChange={(e) => onChange(field.id, e.target.value)}
            onBlur={(e) => onBlur(field.id, e.target.value)}
            disabled={disabled}
          />
        </S.CustomFieldWrapper>
      );
    case 2: // Texto longo
      return (
        <S.CustomFieldWrapper key={field.id}>
          <S.InputLabel>{htmlLabel}</S.InputLabel>
          <S.InputTextArea 
            value={currentValue || ''}
            onChange={(e) => onChange(field.id, e.target.value)}
            onBlur={(e) => onBlur(field.id, e.target.value)}
            disabled={disabled}
          />
        </S.CustomFieldWrapper>
      );
    case 3: // Numérico
      return (
        <S.CustomFieldWrapper key={field.id}>
          <Input
            id={field.id}
            type='number'
            label={htmlLabel}
            name={`customField_${field.id}`}
            value={currentValue || ''}
            onChange={(e) => onChange(field.id, e.target.value)}
            onBlur={(e) => onBlur(field.id, e.target.value)}
            disabled={disabled}
          />
        </S.CustomFieldWrapper>
      );
    case 4: // Single select
    case 5: // Multiple select
      const options = field.values.map(option => ({
        value: option.toLowerCase().replace(/\s/g, ''),
        label: option
      }))
      
      let selectValue;
      if (field.type === 5) {
        // Multi-select: array de objetos {value, label}
        selectValue = options.filter(opt => 
          currentValue && Array.isArray(currentValue) 
            ? currentValue.map(val => val?.toLowerCase().replace(/\s/g, '')).includes(opt.value)
            : []
        )
      } else {
        // Single-select: objeto {value, label} ou null
        selectValue = options.find(opt => 
          currentValue?.toLowerCase().replace(/\s/g, '') === opt.value
        ) || ""
      }

      if (selectValue?.length === 0) {
        selectValue = [""]
      }

      return (
        <S.CustomFieldWrapper key={field.id} style={{marginBottom: '1rem'}}>
          <S.InputLabel>{htmlLabel}</S.InputLabel>
          <Select
            value={selectValue}
            onChange={(val) => onChange(field.id, val, true)}
            options={options}
            isMulti={field.type === 5}
            isClearable
            styles={themeForSearchableSelect()}
            isDisabled={disabled}
            placeholder=""
          />
        </S.CustomFieldWrapper>
      );
    case 6: // Moeda
      return (
        <S.CustomFieldWrapper key={field.id}>
          <NumericFormat
            id={field.id}
            value={currentValue}
            thousandSeparator="."
            decimalSeparator=","
            prefix="R$ "
            placeholder="R$ 0,00"
            decimalScale={2}
            fixedDecimalScale={true}
            allowNegative={false}
            onValueChange={(values) => {
              onChange(field.id, values.floatValue);
            }}
            onBlur={() => {
              onBlur(field.id, currentValue);
            }}
            customInput={Input}
            label={htmlLabel}
            name={`customField_${field.id}`}
            disabled={disabled}
          />
        </S.CustomFieldWrapper>
      );
    default:
      return null
  }
}

export default CustomField